import {
  AbstractControl,
  FormControl,
  FormGroup,
  UntypedFormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms';
import { instanceOfCrewDto } from '@sd-portal/shared/crew';

import { CrewMemberLogbookForm } from './crew-member-logbook-form.model';
import { FlightCrewMember } from './flight-crew-member.model';
import { AutomatedLogbookData } from './automated-logbook-data.model';

export function crewMemberTypeRequiredValidator(): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const crewMemberControl = group.get('crewMember');
    const crewMemberTypeControl = group.get('crewMemberTypeId');
    if (!crewMemberControl || !crewMemberTypeControl) {
      return null;
    }

    const hasCrewMemberAssigned = instanceOfCrewDto(crewMemberControl.value);
    const hasCrewMemberType = !!crewMemberTypeControl.value;

    if (hasCrewMemberAssigned && !hasCrewMemberType) {
      if (!crewMemberTypeControl.hasError('required')) {
        crewMemberTypeControl.setErrors({ ...crewMemberTypeControl.errors, required: true });
      }
      return { crewMemberTypeRequired: true };
    }

    if (crewMemberTypeControl.hasError('required')) {
      const remainingErrors = { ...crewMemberTypeControl.errors };
      delete remainingErrors.required;
      crewMemberTypeControl.setErrors(Object.keys(remainingErrors).length ? remainingErrors : null);
    }

    return null;
  };
}

export class FlightCrewMemberForm {
  flightCrewMemberId: FormControl = new FormControl(0);
  flightId: FormControl = new FormControl(0);
  crewMember: FormControl = new FormControl('');
  crewMemberTypeId: FormControl = new FormControl(undefined);
  logbook: FormGroup = new UntypedFormGroup(new CrewMemberLogbookForm());
  isAssignedAutomatedData: FormControl = new FormControl(false);
  // index signature
  [key: string]: any; // eslint-disable-line @typescript-eslint/no-explicit-any

  constructor(flightCrewMember?: FlightCrewMember, automatedLogbookData?: AutomatedLogbookData) {
    if (flightCrewMember) {
      this.flightCrewMemberId.setValue(flightCrewMember.flightCrewMemberId);
      this.flightId.setValue(flightCrewMember.flightId);
      this.crewMember.setValue(flightCrewMember.crewMember);
      this.crewMemberTypeId.setValue(flightCrewMember.crewMemberTypeId);
      this.logbook = new UntypedFormGroup(new CrewMemberLogbookForm(flightCrewMember.logbook));
      this.isAssignedAutomatedData.setValue(flightCrewMember.isAssignedAutomatedData);
    }

    if (automatedLogbookData) {
      this.crewMember = new FormControl('', [Validators.required]);
      this.logbook = new UntypedFormGroup(
        new CrewMemberLogbookForm(undefined, automatedLogbookData)
      );
      this.isAssignedAutomatedData.setValue(true);
    }
  }
}
